module.exports = __webpack_public_path__ + "img/status-not-start.c90b8dec.png";